import { Avatar } from "@mui/material";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const AvatarWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",

  maxHeight: 255,
  height: 255,
  border: `1px dashed ${colors.gray300}`,
  borderRadius: 12,
  padding: 12,
}));

export const AvatarImage = styled("img")(() => ({
  height: 255,
  width: "100%",
  objectFit: "cover",
  borderRadius: 12,
}));

export const AvatarComponent = styled(Avatar, {
  shouldForwardProp(propName) {
    return propName !== "isOnViewMode";
  },
})(({ isOnViewMode }: { isOnViewMode: boolean }) => ({
  background: "#fff !important",
  color: "#465869 !important",
  width: 48,
  height: 48,
  border: `1px solid ${colors.gray200}`,
  cursor: isOnViewMode ? "default" : "pointer",
  "& > svg": {
    fontSize: 19,
    cursor: isOnViewMode ? "default" : "pointer",
  },
}));

export const AvatarInput = styled("input")(() => ({
  position: "absolute",
  width: "19px",
  height: "19px",
  opacity: 0,
  display: "none",
}));

export const TextWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  marginTop: 12,
  fontFamily: "'Manrope', sans-serif",
  "& p": {
    color: colors.gray600,
    fontWeight: 600,
    fontSize: 14,
    lineHeight: "20px",
    marginBottom: 1,
    "&.subtext": {
      color: colors.gray500,
      fontWeight: 400,
    },
  },
}));

export const ButtonWrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: 24,
  justifyContent: "center",
  marginTop: 24,
  "& > input": {
    display: "none",
  },
}));
